import { Constants, CYBER_CONSTANT } from 'constants';

import React from 'react';
import { Carousel, Typography } from '@genie-ui/react';
import PropTypes from 'prop-types';
import {
  convertToLastDate,
  trimText,
} from 'utils';

import './CarousalComponent.scss';

function CarousalComponent({
  isRR,
  data,
  actisData,
  kpiName,
  isPeer,
}) {
  const openRRLink = (url, title, docCd, index) => () => {
    window.open(url, '_blank');
    if (isRR) {
      if (kpiName) {
        window.pushEvent?.(
          {
            ...actisData,
            ...(!isPeer
              ? CYBER_CONSTANT.ACTIS.RECOMMENDED_RESOURCES
              : CYBER_CONSTANT.ACTIS.PEER_DISCUSSIONS),
            activityValue: docCd ? `${title} | ${docCd}` : title,
            kpi: kpiName,
            activityMeta: 'Metric',
            placementInCarousel: index,
          },
          Constants.LABELS.ACTIS_KEY_CYBER,
        );
      } else {
        window.pushEvent?.(
          {
            ...CYBER_CONSTANT.ACTIS.RECOMMENDED_RESOURCES_MAIN_PAGE,
            ...actisData,
            activityValue: docCd ? `${title} | ${docCd}` : title,
            activityMeta: 'Dashboard',
            placementInCarousel: index,
          },
          Constants.LABELS.ACTIS_KEY_CYBER,
        );
      }
    } else {
      window.pushEvent?.(
        {
          ...CYBER_CONSTANT.ACTIS.RECOMMENDED_TOOLS,
          ...actisData,
          activityValue: title,
          placementInCarousel: index,
        },
        Constants.LABELS.ACTIS_KEY_CYBER,
      );
    }
  };

  const rrItems = data.map((item, index) => (
    {
      id: index + 1,
      component: (
        <div
          className="caraousalCard"
          onClick={openRRLink(
            item?.url,
            item?.title,
            item?.docCd,
            index + 1,
          )}
          role="link"
          tabIndex={0}
        >
          <Typography className="caraousalCardTitle">
            {item?.title}
          </Typography>
          <div className="caraousalCardTypeDate">
            <Typography className="caraousalCardType">
              {item?.type?.replace(CYBER_CONSTANT.RR_DOCUMENT, '')}
            </Typography>
            {item?.publishedDate && (
              <Typography className="caraousalCardDate">
                {convertToLastDate(item?.publishedDate)}
              </Typography>
            )}
          </div>
          <Typography className="caraousalCardSummary">
            {trimText(item?.description, CYBER_CONSTANT.RR_TEXT_LIMIT)}
          </Typography>
        </div>
      ),
    }
  ));

  const toolsItems = data.map((item, index) => (
    {
      id: index + 1,
      component: (
        <div
          className="caraousalCard toolsCardGap"
          onClick={openRRLink(
            item?.url,
            item?.title,
            item?.docCd,
            index + 1,
          )}
          role="link"
          tabIndex={0}
        >
          <Typography className="caraousalCardToolTitle">
            {item?.title}
          </Typography>
          <Typography className="caraousalCardSummary">
            {trimText(item?.description, CYBER_CONSTANT.RR_TEXT_LIMIT)}
          </Typography>
        </div>
      ),
    }
  ));

  return <Carousel items={isRR ? rrItems : toolsItems} />;
}

CarousalComponent.propTypes = {
  isRR: PropTypes.bool,
  data: PropTypes.arrayOf(Object),
  actisData: PropTypes.instanceOf(Object),
  kpiName: PropTypes.string,
  isPeer: PropTypes.bool,
};

CarousalComponent.defaultProps = {
  isRR: false,
  data: [],
  actisData: {},
  kpiName: '',
  isPeer: false,
};

export default CarousalComponent;
